import React, { useEffect } from "react";
import { observer } from "mobx-react";

import {
	EventContext,
	LookupContext,
	OfferStoreContext,
	SportOfferContext,
} from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";

import { EmptyOfferMessage } from ".";
import EventTemplate from "./EventTemplate";

export default observer(function EventPageCore({
	store,
}: {
	store: EventViewStore;
}) {
	useEffect(() => {
		if (store.sportStatisticsStore.pressureIndex?.chartRef?.reflow) {
			store.sportStatisticsStore.pressureIndex?.chartRef?.reflow();
		}
	}, [store.isStoreInitialized]);

	if (store.isLoading) {
		return (
			<div className="col u-mar--bottom--xsml event--multi__col">
				<div className="event event--page event--live event--multi loader--skeleton skeleton--event" />
			</div>
		);
	}

	if (store.isEmpty) {
		return (
			<div className="col u-mar--bottom--xsml event--multi__col">
				<EmptyOfferMessage store={store} />
			</div>
		);
	}

	if (!store.events.length) {
		return null;
	}

	return (
		<>
			{store.events.map((event) => (
				<OfferStoreContext.Provider
					value={store}
					// @ts-expect-error
					key={event?.sport?.id + event?.id}
				>
					<LookupContext.Provider value={store.lookupsStore}>
						<SportOfferContext.Provider
							// @ts-expect-error
							key={event?.sport?.id + event?.id}
							// @ts-expect-error
							value={event?.sport}
						>
							<EventContext.Provider value={event}>
								<EventTemplate />
							</EventContext.Provider>
						</SportOfferContext.Provider>
					</LookupContext.Provider>
				</OfferStoreContext.Provider>
			))}
		</>
	);
});
